import { webApi } from '@mi-front/api-clients';
import { useMemo } from 'react';

/**
 * Composition publish flow only allows video-editor edits with a completed render as the upload source.
 */
export function useCompositionPublishableRenderedEdits(compositionId: string | undefined) {
  const editsListQuery = webApi.useGetCompositionsDetailEdits(compositionId ?? '', {
    query: { enabled: !!compositionId },
  });

  const edits = editsListQuery.data ?? [];
  const editsWithRender = useMemo(
    () => edits.filter((edit) => edit.renderJob?.status === 'COMPLETED'),
    [edits],
  );

  return {
    editsListQuery,
    edits,
    editsWithRender,
    hasAvailableSources: editsWithRender.length > 0,
  };
}
